export default {
  DMMB: require('./DMMB.png'),
  GMOC: require('./GMOC.png'),
  CCJP: require('./CCJP.png'),
  BTBK: require('./BTBK.png'),
  QUON: require('./QUON.png'),
  DCRT: require('./DCRT.png'),
  BTFL: require('./BTFL.png'),
}
